export default __webpack_public_path__ + "static/media/course3.ea5d8a88.png";